import { createActionGroup, props } from '@ngrx/store';

export const CheckoutResolversActions = createActionGroup({
  source: 'Checkout Resolvers',
  events: {
    'Platform Checkout Resolved': props<{
      disablePaymentDate: boolean;
    }>(),
    'Payment Links Checkout Resolved': props<{
      disablePaymentDate: boolean;
    }>(),
  },
});
